<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('../components/core/AppBar'),
      DashboardCoreDrawer: () => import('../components/core/PsychologyDrawer'),
      DashboardCoreSettings: () => import('../components/core/Settings'),
      DashboardCoreView: () => import('../components/core/View'),
    },
  }
</script>
